import { useContext } from 'react';

import { CostOverTimeContext } from '../providers/CostOverTimeProvider';

export const useCostOverTime = () => useContext(CostOverTimeContext);
